import React from 'react';
import IconBase from './Icon-base';
export default class Close extends React.Component {
    render() {
        return (
            <IconBase width="14" height="14" viewBox="0 0 14 14" {...this.props}>
                <g id="Canvas_cl" transform="translate(-296 227)">
                    <g id="Group 7">
                        <g id="Rectangle 3.3">
                            <use
                                xlinkHref="#close_path"
                                transform="matrix(0.707107 0.707107 -0.707107 0.707107 298.05 -226.364)"
                                fill="#4F5056"
                            />
                        </g>
                        <g id="Rectangle 3.4">
                            <use
                                xlinkHref="#close_path"
                                transform="matrix(-0.707107 0.707107 -0.707107 -0.707107 309.364 -224.95)"
                                fill="#4F5056"
                            />
                        </g>
                    </g>
                </g>
                <defs>
                    <path id="close_path" d="M 0 0L 16 0L 16 2L 0 2L 0 0Z" />
                </defs>
            </IconBase>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/SVGIcons/Close.js